import React from 'react';
import PropTypes from 'prop-types';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

const YRBigTable = ({ data, style }) => {
    const colKeys = data[0].values.map(el => el.name);
    const unit = style && style.unit;

    return (
        <div className="yr-table-container is-big">
            <table className="yr-table">
                <thead>
                    <tr>
                        <td />
                        {data.map(item => <th colSpan="2" key={item.name} style={{ textAlign: 'center' }}> {item.name} </th>)}
                    </tr>
                    <tr>
                        <td />
                        {data.map((dataItem, dataIndex) => dataItem.values[dataIndex].values
                            .map(dataObj =>
                                <td key={dataObj.name}>{dataObj.name}</td>))}
                    </tr>
                </thead>
                <tbody>
                    {colKeys.map((colKey, colKeyIndex) => (
                        <tr key={colKey}>
                            <td>{colKey}</td>
                            {data.map(dataItem => dataItem.values[colKeyIndex].values
                                .map((dataObj, idx) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <td key={idx}>
                                        {FormatGraphDataService.twoDecimalPlaces(dataObj.values)}
                                        {unit}
                                    </td>)))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
YRBigTable.defaultProps = {
    style: {},
};

YRBigTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    style: PropTypes.objectOf(PropTypes.any),
};

export default YRBigTable;
